import React, {FC} from "react"

import connect from "./connect"
import {StyledFacetButton, TextWrapper} from "../components"
import {SelectedFacetIndicator, ShowFiltersStyling} from "./components"
import ShowFiltersText from "../showFiltersText"

export interface Props {
    facetDisplayName: string
    noBorder?: boolean
    facetName: string
    setSelectedFacet: ({facetName, facetDisplayName}: {facetName: string; facetDisplayName: string}) => void
    isFocused?: boolean
    hasSelectedFacet: boolean
    hideTopBorder: boolean
    hasSelectedFilters: boolean
    selectedFacetFilters?: string
    disabled: boolean | undefined
}

export const TabbedFacet: FC<Props> = ({
    facetDisplayName,
    noBorder,
    setSelectedFacet,
    isFocused,
    hasSelectedFacet,
    hideTopBorder,
    hasSelectedFilters,
    facetName,
    selectedFacetFilters,
    disabled,
}) => (
    <StyledFacetButton
        onClick={() => setSelectedFacet({facetName, facetDisplayName})}
        isFocused={isFocused}
        hideTopBorder={hideTopBorder}
        showLeftBorder={hasSelectedFilters}
        data-testid={`plp-tabbed-filter-button-${facetName}`}
    >
        {hasSelectedFilters && !isFocused && hasSelectedFacet && (
            <SelectedFacetIndicator data-testid="plp-tabbed-facets-selected-dot" />
        )}
        <TextWrapper fullWidth noBorder={hasSelectedFacet || noBorder}>
            <ShowFiltersText
                variant={hasSelectedFilters && isFocused ? "h5" : "body1"}
                component="h2"
                disabled={disabled}
            >
                {facetDisplayName}
            </ShowFiltersText>
            {hasSelectedFilters && selectedFacetFilters && (
                <ShowFiltersText
                    $isSecondary
                    childtestid={`plp-tabbed-facets-selected-filter-${facetName}`}
                    component="h2"
                >
                    <ShowFiltersStyling>{selectedFacetFilters}</ShowFiltersStyling>
                </ShowFiltersText>
            )}
        </TextWrapper>
    </StyledFacetButton>
)

export default connect(TabbedFacet)
